module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Tulip-Fever.9e1cf47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Tulip-Fever.jpg
// module id = J0lh
// module chunks = 0